@if (vm$ | async; as vm) {
  <div class="container-fluid h-full">
    <div class="row h-full">
      <div class="col h-full">
        <cat-topic-item
          (changeCoreId)="repository.setCoreId($event)"
          (search)="onSearch($event[0], $event[1])"
          [activeCoreId]="vm.coreId"
          [cores]="vm.cores"
          [topicRegisterItems]="vm.topicRegisterItems"
          [topic]="vm.topic"
        ></cat-topic-item>
      </div>
    </div>
  </div>
  <aipb-inside-loading [loading]="vm.loading"></aipb-inside-loading>
}
